import {
  NotificationsPaginator,
  NotificationStatus
} from '@shared/types/notifications.types'
import { User } from '@shared/types/users.types'
import { useQuery } from '@tanstack/react-query'
import axiosClient from '../useAxios'

export const useUser = (userId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['users', userId],
    queryFn: async (): Promise<User> => {
      const response = await axiosClient.get(`/users/${userId}`)
      return response.data.data.user
    },
    staleTime: 0,
    enabled: enabled && !!userId
  })
}

export const useNotifications = (
  userId: string,
  queryParams?: {
    pageNumber?: string
    pageSize?: string
    status?: NotificationStatus
    companyId?: string
  }
) => {
  return useQuery({
    queryKey: ['users', userId, 'notifications', queryParams],
    queryFn: async (): Promise<NotificationsPaginator> => {
      const searchParams = new URLSearchParams()

      if (queryParams?.pageNumber) {
        searchParams.append('pageNumber', queryParams.pageNumber)
      }
      if (queryParams?.pageSize) {
        searchParams.append('pageSize', queryParams.pageSize)
      }
      if (queryParams?.status) {
        searchParams.append('status', queryParams.status)
      }
      if (queryParams?.companyId) {
        searchParams.append('companyId', queryParams.companyId)
      }

      const queryString = searchParams.toString()
      const url = `/users/${userId}/notifications${queryString ? `?${queryString}` : ''}`

      const response = await axiosClient.get(url)
      return response.data.data
    }
  })
}
